import MainLayout from 'layouts/MainLayout'
import DashboardLayout from 'layouts/DashboardLayout'
import NovelLayout from 'layouts/NovelLayout.vue'
import LyskLayout from 'layouts/LyskLayout.vue'

import Works from 'pages/Works'
import Work from 'pages/Work'
import List from 'pages/List'
import Login from 'pages/Login'
import Favourites from 'pages/Favourites'
import FullScreenPlayer from 'pages/FullScreenPlayer'
import AILyricCenter from 'pages/AILyricCenter'

import FakeWorks from 'pages/Fake/Works'
import FakeWork from 'pages/Fake/Work'
import FakeSpider from 'pages/Fake/Spider'

import Folders from 'pages/Dashboard/Folders'
import Scanner from 'pages/Dashboard/Scanner'
import Advanced from 'pages/Dashboard/Advanced'
import UserManage from 'pages/Dashboard/UserManage'

import Main  from 'src/pages/Main'
import NovelWorks from 'pages/Novel/Works'
import NovelWork from 'pages/Novel/Work'
import NovelList from 'pages/Novel/NovelList'
import NovelLogin from 'pages/Login'
import NovelFavourites from 'pages/Novel/Favourites'
import NovelFullScreenPlayer from 'pages/FullScreenPlayer'
import NovelAILyricCenter from 'pages/AILyricCenter'
import AddNovel from 'pages/Novel/AddNovel'

import LyskMain  from 'src/pages/Lysk/Main'
function prefixRoutes(prefix, routes) {
  return routes.map((route) => {
    route.path = prefix + '' + route.path;
    return route;
  });
}

const routes = [
  {
    path: '/admin',
    component: DashboardLayout,
    children: [
      {
        path: '',
        component: Folders
      },
      {
        path: 'scanner',
        component: Scanner
      },
      {
        path: 'advanced',
        component: Advanced
      },
      {
        path: 'usermanage',
        component: UserManage
      }
    ]
  },
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '',
        redirect: {
          name: 'main'
        }
      },
      {
        path: 'works',
        name: 'works',
        component: Works
      },
      {
        path: 'work/:id',
        component: Work
      },
      {
        path: 'search',
        name: 'advance search', // 必要，Works页面根据这个name判断是否开启高级搜索功能
        component: Works,
      },
      {
        path: 'circles',
        props: { restrict: "circles" },
        component: List
      },
      {
        path: 'tags',
        props: { restrict: "tags" },
        component: List
      },
      {
        path: 'vas',
        props: { restrict: "vas" },
        component: List
      },
      {
        path: 'fullScreenPlayer/:id?',
        component: FullScreenPlayer
      },
      {
        path: 'ai_lyric',
        component: AILyricCenter
      },
      ...prefixRoutes('favourites', [
        {
          path: '',
          props: { route: 'histroy'},
          component: Favourites,
        },
        {
          path: '/review',
          props: { route: 'review'},
          component: Favourites,
        },
        ...prefixRoutes('/progress', [
          {
            path: '',
            props: { route: 'progress', progress: 'marked'},
            component: Favourites,
          },
          {
            path: '/marked',
            props: { route: 'progress', progress: 'marked'},
            component: Favourites,
          },
          {
            path: '/listening',
            props: { route: 'progress', progress: 'listening'},
            component: Favourites,
          },
          {
            path: '/listened',
            props: { route: 'progress', progress: 'listened'},
            component: Favourites,
          },
          {
            path: '/replay',
            props: { route: 'progress', progress: 'replay'},
            component: Favourites,
          },
          {
            path: '/postponed',
            props: { route: 'progress', progress: 'postponed'},
            component: Favourites,
          },
        ]),
        {
          path: '/folder',
          props: { route: 'folder'},
          component: Favourites,
        },
        {
          path: '/histroy',
          props: { route: 'histroy'},
          component: Favourites,
        },
      ]),
    ],
    meta: {
      auth: true
    }
  },
  {
    path: '/fake',
    component: MainLayout,
    children: [
      {
        path: 'works',
        name: 'fake_works',
        component: FakeWorks
      },
      {
        path: 'work/:id',
        name: 'fake_work',
        component: FakeWork
      },
      {
        path: 'spider',
        name: 'fake_spider',
        component: FakeSpider
      },]
    },
  {
    path: '/novel',
    component: NovelLayout,
    children: [
      {
        path: 'works',
        name: 'novel_works',
        component: NovelWorks
      },
      {
        path: 'add',
        name: 'novel_add',
        component: AddNovel
      },
      {
        path: 'work/:id',
        component: NovelWork
      },
      {
        path: 'search',
        name: 'advance search', // 必要，Works页面根据这个name判断是否开启高级搜索功能
        component: NovelWorks,
      },
      {
        path: 'circles',
        props: { restrict: "circles" },
        component: NovelList
      },
      {
        path: 'tags',
        props: { restrict: "tags" },
        component: NovelList
      },
      {
        path: 'vas',
        props: { restrict: "vas" },
        component: NovelList
      },
      {
        path: 'fullScreenPlayer/:id?',
        component: NovelFullScreenPlayer
      },
      {
        path: 'ai_lyric',
        component: NovelAILyricCenter
      },
      ...prefixRoutes('favourites', [
        {
          path: '',
          props: { route: 'review'},
          component: NovelFavourites,
        },
        ...prefixRoutes('/progress', [
          {
            path: '',
            props: { route: 'progress', progress: 'marked'},
            component: NovelFavourites,
          },
          {
            path: '/marked',
            props: { route: 'progress', progress: 'marked'},
            component: NovelFavourites,
          },
          {
            path: '/listening',
            props: { route: 'progress', progress: 'listening'},
            component: NovelFavourites,
          },
          {
            path: '/listened',
            props: { route: 'progress', progress: 'listened'},
            component: NovelFavourites,
          },
          {
            path: '/replay',
            props: { route: 'progress', progress: 'replay'},
            component: NovelFavourites,
          },
          {
            path: '/postponed',
            props: { route: 'progress', progress: 'postponed'},
            component: NovelFavourites,
          },
        ]),
        {
          path: '/folder',
          props: { route: 'folder'},
          component: NovelFavourites,
        },
        {
          path: '/histroy',
          props: { route: 'histroy'},
          component: NovelFavourites,
        },
      ]),
    ],
    meta: {
      auth: true
    }
  },
  {
    path: '/lysk',
    component: LyskLayout,
    children: [
      {
        path:'main',
        name:'Lysk_main',
        component:LyskMain
      }
    ]
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/main',
    name: 'main',
    component: Main
  },
]

// Always leave this as last one
// eslint-disable-next-line
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/Error404.vue')
  })
}

export default routes
